<div class="container">
    <div class="row">
        <div class="col-4">
            <h4>Week of: {{weekName}}</h4>
        </div>
        <div class="col-2">
            <button class="btn btn-primary" (click)="toggleChangeParasha()">{{changeParasha?'Save':'Change'}}</button>
        </div>

        <div class="col-6">
            <textarea class="form-control" placeholder="Enter a message to be sent to all list recipients (optional)"
                [(ngModel)]="message" rows="2"></textarea>
        </div>
    </div>
    <div class="row">
        <div *ngIf="changeParasha">
            <!--Parasha week-->
            <div class="col-3" [ngClass]="{emphasized:radioParasha.checked}">
                <div class="custom-control custom-radio">
                    <input (change)="updateParasha()" type="radio" class="custom-control-input give-space"
                        id="radioParasha" name="weekType" #radioParasha value="parashaRadio" [(ngModel)]="radioChosen">
                    <label class="custom-control-label" for="radioParasha">Parasha name:</label>
                </div>
                <select class="set-width form-control" #parashaTag [(ngModel)]="selectedParasha"
                    (change)="emphasize('parashaRadio'); updateParasha(); ">
                    <option *ngFor="let p of adminService.parashot" [ngValue]="p">
                        {{p.englishName}} - {{p.hebrewName}}</option>
                </select>
            </div>

            <!--Chag week-->
            <div class="col-3" [ngClass]="{emphasized:radioChag.checked}">
                <div class="custom-control custom-radio">
                    <input (change)="updateChag()" type="radio" class="custom-control-input give-space" id="radioChag"
                        #radioChag name="weekType" value="chagRadio" [(ngModel)]="radioChosen">
                    <label class="custom-control-label" for="radioChag">Special week: </label>
                </div>

                <select (change)="emphasize('chagRadio'); updateChag()" class="form-control set-width"
                    [(ngModel)]="chag" #chagTag>
                    <option *ngFor="let c of adminService.chagim" [ngValue]="c">{{c.englishName}} -
                        {{c.hebrewName}}</option>
                </select>
            </div>

            <!--Custom week-->
            <div class="col-3" [ngClass]="{emphasized:radioCustom.checked}">
                <div class="custom-control custom-radio">
                    <input (change)="updateCustom(customTag.value); " type="radio"
                        class="custom-control-input give-space" id="radioCustom" #radioCustom name="weekType"
                        value="customRadio" [(ngModel)]="radioChosen">
                    <label class="custom-control-label" for="radioCustom">Other: </label>
                </div>

                <input class="form-control set-width" placeholder="Enter week title"
                    (keyup)="updateCustom(customTag.value)"
                    (focus)="emphasize('customRadio'); updateCustom(customTag.value)" [(ngModel)]="customWeek"
                    type="text" #customTag>
            </div>
        </div>

    </div>
    <div class="row">
        <div class="col-3">
            <h4>Category this week: </h4>
        </div>
        <div class="col-2">
            <select class="form-control set-width" [(ngModel)]="selectedCategory" (ngModelChange)="refreshDavenfors()">
                <option *ngFor="let c of categories" [ngValue]="c">{{c | viewCategory}}
                </option>

            </select>
        </div>
        <div class="col-7 d-flex align-items-center">
            <button class="btn btn-warning btn-lg"
                [disabled]="noDavenfors || (daveningService.loading())"
                (click)="preview()">Preview</button>

            <button class="btn btn-success btn-lg" (click)="requestToSend()"
                [disabled]="askForPassword || sentOnce || noDavenfors || noUsers">Send List</button>

            <span *ngIf="askForPassword && !noUsers" class="d-flex align-items-center password-span">
                <input [(ngModel)]="adminPassword" type="password" class="form-control red-font admin-pass"
                    placeholder="Admin password">
                <button class="btn btn-danger cancel-pass" (click)="cancelPass()">X</button>

                <div *ngIf="!askForPassword && noUsers" style="text-align: center;">
                    <span class="red-font">There are no active users. Cannot send list</span>
                </div>

                <div *ngIf="askForPassword && !noUsers">
                    <button class="btn btn-success" (click)="verify()"
                        [disabled]="adminPassword.length == 0 || noDavenfors || noUsers">Verify</button>
                </div>
            </span>
        </div>

        <app-loading-spinner
            [isLoading]="!finishedLoading || (daveningService.loading()) && readyToSend"></app-loading-spinner>
    </div>
    <hr>
    <div class="div-names" *ngIf="finishedLoading">
        <app-select-davenfors [davenfors]="selectedDavenfors" [category]="selectedCategory"
            [adminPermission]="true"></app-select-davenfors>
    </div>
</div>